import React, { useState } from "react";
import { CancelOutlined } from "@mui/icons-material";
import { Alert, Box, Button, TextField } from "@mui/material";
import LabeledField from "../../components/form/LabeledField";
import { WorkflowCancelConfig } from "./workflowBuilderData";

interface WorkflowCancelStageProps {
  config: WorkflowCancelConfig;
  onCancel: (reason: string) => void;
  /** A cancel is in flight. */
  busy?: boolean;
  banner?: React.ReactNode;
}

const WorkflowCancelStage: React.FC<WorkflowCancelStageProps> = ({ config, onCancel, busy = false, banner }) => {
  const [note, setNote] = useState(config.defaultNote);
  const [noteError, setNoteError] = useState(false);

  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNote(event.target.value);
    setNoteError(false);
  };

  const handleCancel = () => {
    const reason = note.trim();
    if (config.noteRequired && !reason) {
      setNoteError(true);
      return;
    }
    onCancel(reason);
  };

  return (
    <>
      <Alert severity="error" className="workflow-run__alert--flush">
        This canvas cancels the case.
        {config.noteRequired ? " A reason is required." : ""}
      </Alert>

      <LabeledField
        controlId="workflow-cancel-reason"
        label={`Cancel reason${config.noteRequired ? "" : " (optional)"}`}
        required={config.noteRequired}
        className="workflow-run__approval-note"
        error={noteError ? "Enter a reason before cancelling this case." : undefined}
      >
        <TextField
          id="workflow-cancel-reason"
          placeholder="Why is this case being cancelled?"
          size="small"
          fullWidth
          required={config.noteRequired}
          multiline
          minRows={3}
          value={note}
          onChange={handleNoteChange}
          error={noteError}
        />
      </LabeledField>

      {banner}

      <Box className="workflow-run__actions workflow-run__actions--end">
        <Button
          className="workflow-run__decision workflow-run__decision--reject"
          variant="contained"
          startIcon={<CancelOutlined />}
          onClick={handleCancel}
          disabled={busy}
        >
          Cancel the case
        </Button>
      </Box>
    </>
  );
};

export default WorkflowCancelStage;
